import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IImageURL, ISafeHTML } from "../../models/nominals";
import { UncontrolledPopover } from "../Popover";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

// Reactivated passes plain string; legacy io-ts path passes branded newtypes.
// Remove once the io-ts branded types are retired.
const unwrapStr = (v: string | ISafeHTML | IImageURL): string =>
    v as unknown as string;

export type IValuePropData = {
    title: string | ISafeHTML;
    subtitle: string | ISafeHTML;
    show_tooltip: boolean;
    tooltip_contents: string | ISafeHTML;
    icon?: {
        id: number;
        title: string;
        url: string | IImageURL;
    };
};

type IProps = Immutable<{
    prop: IValuePropData;
    className?: string;
}>;

const ValueProp = (props: IProps): React.ReactNode => {
    const content = (
        <>
            {props.prop.icon && (
                <img
                    loading="lazy"
                    src={unwrapStr(props.prop.icon.url)}
                    alt=""
                />
            )}
            <div
                className="value-prop-list-item__copy"
                dangerouslySetInnerHTML={{
                    __html:
                        unwrapStr(props.prop.title) +
                        unwrapStr(props.prop.subtitle),
                }}
            />
        </>
    );

    const listItemClasses = classNames(styles.listItem, props.className || "");

    if (!props.prop.show_tooltip) {
        return (
            <li className={listItemClasses}>
                <span>{content}</span>
            </li>
        );
    }

    const modalClasses = classNames(styles.modal, "place-bottom");

    return (
        <li className={listItemClasses}>
            <UncontrolledPopover
                triggerContent={content}
                triggerBtnProps={{}}
                popperOptions={{
                    modifiers: [
                        {
                            name: "offset",
                            options: { offset: [0, 16] },
                        },
                        {
                            name: "flip",
                            options: {
                                fallbackPlacements: ["top", "bottom"],
                            },
                        },
                    ],
                    placement: "bottom",
                }}
                modalProps={{
                    className: modalClasses,
                    contentLabel: t`Offers`,
                    bodyOpenClassName: "ReactModal__Body--open vp-popover-open",
                    style: {
                        overlay: {
                            backgroundColor: "transparent",
                        },
                    },
                }}
            >
                <RichText html={props.prop.tooltip_contents} />
            </UncontrolledPopover>
        </li>
    );
};

export default ValueProp;
